import AddBossMode from './AddBossMode.component';

export default AddBossMode;